import { Card, Col, Container, Row } from 'reactstrap';
import { PaymentHubDebtsData } from '../loaders/PaymentHubDebtsData';
import IdentificationTable from './DebtsTable';
import IdentificationFilter from './IdentificationFilter';

export const PaymentHubDebts = () => {
  return (
    <div className="mx-3 d-flex justify-content-center">
      <PaymentHubDebtsData defaultQuery={{}} fetchImmediately>
        <div className="w-100">
          <IdentificationFilter />
          <Container fluid>
            <Row className="pb-4 gutters-filters">
              <Col xs={12}>
                <Card>
                  <IdentificationTable />
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </PaymentHubDebtsData>
    </div>
  );
};
